import { v4 } from 'uuid';
export const blockDraftAsyncLocalChanges = (args, store) => {
    if (args.type === 'Publish') {
        return handleBlockPublish(args.input, store);
    }
    else if (args.type === 'Print') {
        return handlePrint(args.input);
    }
    else if (args.type === 'DeletePrintTask') {
        return handleDelete(args.input.printTaskId, 'BlockPrintTask');
    }
    else {
        const _ = args;
        return [];
    }
};
const handleBlockPublish = (input, store) => {
    const { blockId } = input;
    const existingTask = store.getOne('BlockPublishTask', { blockId });
    const taskId = v4();
    return [
        ...(existingTask
            ? [
                {
                    modelName: 'BlockPublishTask',
                    modelId: existingTask.id,
                    action: 'delete',
                },
            ]
            : []),
        {
            modelName: 'BlockPublishTask',
            modelId: taskId,
            action: 'create',
            data: {
                id: taskId,
                blockId,
                status: 'pending',
                totalWorkouts: 0,
                completedWorkoutIds: [],
                failedWorkouts: {},
            },
        },
    ];
};
const handlePrint = (input) => {
    return [
        {
            modelName: 'BlockPrintTask',
            modelId: input.printTaskId,
            action: 'create',
            data: {
                id: input.printTaskId,
                blockId: input.blockId,
                profileIds: input.profileIds,
                workoutIds: input.workoutIds,
                printOptions: input.printOptions,
                pdfUrl: null,
                status: 'pending',
            },
        },
    ];
};
const handleDelete = (taskId, modelName) => {
    return [
        {
            modelName,
            modelId: taskId,
            action: 'delete',
        },
    ];
};
//# sourceMappingURL=block-draft-async.js.map